/* INTENTION — creator page fit quiz.
   Extracted from the inline <script> in sections/creator-collection-story.liquid
   on 2026-09-12. The section now prints one JSON island, #int-cfq-cfg, and this
   file holds every line of behaviour. Loaded with defer, so it is cached across
   creator pages instead of being rebuilt by the server on every view.

   ⚑ A .js asset is NEVER Liquid parsed. Anything that has to come from Liquid,
   the metaobject fit data, the creator's current pick and all English copy,
   travels in #int-cfq-cfg. Nothing in this file may reference Liquid.

   ⚑ Garment data is NOT owned here. Icons, names and measurements come from the
   fit_style metaobjects, the same source the PDP fit quiz reads
   (snippets/fake-fit-quiz.liquid). Descriptions come from the int_pdp.fit_desc_*
   locale strings, again the same ones the PDP uses, so they translate and cannot
   contradict it. Keep the two consistent.

   ⚑ 2026-10-05: EasySize removed. The quiz button opens Find My Size
   (window.INT_FMS.open, assets/int-fms.js); its Select stores int_fit_size_<style>
   and fires int-fms:pick, which repaints the note below. */
(function(){
  'use strict';

  var CFG = {};
  try { CFG = JSON.parse((document.getElementById('int-cfq-cfg') || {}).textContent || '{}'); } catch(e){}

  var FIT    = CFG.fit    || {};
  var ORDER  = CFG.order  || [];
  var LABELS = CFG.labels || {};
  var T      = CFG.i18n   || {};


  function fill(tpl, map){
    var s = String(tpl || '');
    for (var k in map) { if (Object.prototype.hasOwnProperty.call(map, k)) s = s.split('{'+k+'}').join(map[k]); }
    return s;
  }
  function labelFor(k){ return LABELS[k] || (FIT[k] && FIT[k].name) || k; }

  var active = CFG.active, unit = "cm";
  if(!FIT[active]) active = ORDER[0];

  /* One ink per icon. The house set separates the heavy contour from the light
     detail by STROKE WEIGHT, not by colour, so both groups take the same colour
     and only the active state changes it. Carbon, and a carbon tint for the
     styles that are not selected. */
  var INK_ON='#2B2B2B', INK_OFF='#C4C0B8';

  function svgIcon(key,on){
    // Icons come from the generated asset assets/int-fit-icons.js when it has
    // executed, and from the #int-cfq-cfg island when it has not, so a rollback
    // or a half-deployed theme still paints. See PASS 51.
    var c=(window.INT_FIT_ICONS && window.INT_FIT_ICONS[key]) || (FIT[key] && FIT[key].icon);
    if(!c || !c.body) return '';
    var col=on?INK_ON:INK_OFF;
    var det=(c.det||[]).map(function(d){return '<path d="'+d+'"/>';}).join('');
    var dots=(c.dots||[]).map(function(p){return '<circle cx="'+p[0]+'" cy="'+p[1]+'" r="1.7"/>';}).join('');
    return '<svg viewBox="0 0 120 120" fill="none" stroke="'+col+'"'
      + ' stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">'
      + '<g stroke-width="4"><path d="'+c.body+'"/></g>'
      + (det?'<g stroke-width="2.1">'+det+'</g>':'')
      + (dots?'<g fill="'+col+'" stroke="none">'+dots+'</g>':'')
      + '</svg>';
  }
  function rememberedSize(key){
    try { var s=localStorage.getItem('int_fit_size_'+key); if(s && FIT[key].sizes[s.toUpperCase()]) return s.toUpperCase(); } catch(e){}
    return FIT[key].sizes.M ? 'M' : Object.keys(FIT[key].sizes)[0];
  }
  function measLine(key){
    var sz=rememberedSize(key), d=FIT[key].sizes[sz], inch=unit==='in';
    function v(cm){return inch?(Math.round(cm/2.54*10)/10)+'″':cm+' cm';}
    return fill(T.meas, { size: sz, length: v(d[0]), chest: v(d[1]) });
  }

  var grid=document.getElementById('cfq-grid');
  var nameEl=document.getElementById('cfq-name');
  var descEl=document.getElementById('cfq-desc');
  var measEl=document.getElementById('cfq-meas');
  var recoSlot=document.getElementById('cfq-reco-slot');
  var ctaEl=document.getElementById('cfq-cta');
  if(!grid || !ctaEl) return;

  function renderGrid(){
    grid.innerHTML=ORDER.map(function(k){
      var on=k===active;
      return '<button type="button" class="cfq-cell" data-k="'+k+'" aria-pressed="'+on+'">'
        +'<span class="cfq-cell-icon">'+svgIcon(k,on)+'</span>'
        +'<span class="cfq-cell-label">'+labelFor(k)+'</span></button>';
    }).join('');
    grid.querySelectorAll('.cfq-cell').forEach(function(b){
      b.addEventListener('click',function(){ active=b.getAttribute('data-k'); renderGrid(); renderNote(); });
    });
  }
  function renderNote(){
    nameEl.textContent=fill(T.this_style, { name: FIT[active].name });
    descEl.textContent=FIT[active].desc;
    measEl.textContent=measLine(active);
    ctaEl.textContent=fill(T.cta, { label: labelFor(active) });
    var hasReco=false; try { hasReco=!!localStorage.getItem('int_fit_size_'+active); } catch(e){}
    recoSlot.innerHTML = hasReco
      ? '<div class="cfq-reco"><svg width="12" height="12" viewBox="0 0 16 16" fill="#00FFBF"><path d="M6.4 11.2 2.6 7.4 3.7 6.3 6.4 9 12.4 3 13.5 4.1 Z"/></svg>'+fill(T.reco, { size: rememberedSize(active) })+'</div>'
      : '';
  }

  function openFitQuiz(key){
    if(window.INT_FMS&&window.INT_FMS.open){ window.INT_FMS.open(key); }
  }

  ctaEl.addEventListener('click',function(){ openFitQuiz(active); });
  document.querySelectorAll('.cfq-unit button').forEach(function(btn){
    btn.addEventListener('click',function(){
      unit=btn.getAttribute('data-u');
      document.querySelectorAll('.cfq-unit button').forEach(function(x){ x.classList.toggle('on', x.getAttribute('data-u')===unit); });
      renderNote();
    });
  });

  document.addEventListener('int-fms:pick',function(){ renderNote(); });
  renderGrid(); renderNote();
})();
